import FAQ from './faq';
import { HIWHero, HIWPageContent, HIWPageWrapper } from './styled';

const HowItWorks = () => (
	<HIWPageWrapper>
		<HIWPageContent>
			<HIWHero>
				<h1>How it works</h1>
			</HIWHero>
			<FAQ />
		</HIWPageContent>
	</HIWPageWrapper>
);

export default HowItWorks;
